import React from "react";

export default function MSAccess_CurrentUser() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MSAccess_CurrentUser</h1>
      <p>This is the MSAccess_CurrentUser component generated from the SQL JSON.</p>
    </div>
  );
}
